export function b2Scalar(value) {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) {
    return numeric;
  }
  return numeric;
}

export function b2Vec2Like(target) {
  if (!target) {
    return target;
  }
  target.x = b2Scalar(target.x);
  target.y = b2Scalar(target.y);
  return target;
}
